import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const DEFAULT_SITE_NAME = 'Rejumist™';

const SiteSettingsContext = createContext({
  settings: { site_name: DEFAULT_SITE_NAME },
  siteName: DEFAULT_SITE_NAME,
  loading: true,
  refresh: () => {},
});

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({ site_name: DEFAULT_SITE_NAME });
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    try {
      const { data } = await axios.get(`${API}/api/cms/settings`);
      if (data && typeof data === 'object') {
        setSettings({ ...data, site_name: data.site_name || DEFAULT_SITE_NAME });
      }
    } catch {
      // Silent fallback — keep default so the UI never breaks
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchSettings(); }, []);

  const value = {
    settings,
    siteName: settings.site_name || DEFAULT_SITE_NAME,
    loading,
    refresh: fetchSettings,
  };

  return (
    <SiteSettingsContext.Provider value={value}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
export const useSiteName = () => useContext(SiteSettingsContext).siteName;
